import axios from "axios";

export default class Room {

    constructor( manager ) {
        this.manager = manager
        this.room = null;
        this.botPersonId = 'Y2lzY29zcGFyazovL3VzL1BFT1BMRS84ODNkYjY1MS1mNzc3LTQzYmItOTBhYS0xMzc2ZDYwODYyZmQ';
        this.agents = {
            marco_z: {
                email: 'marco.zancan@delbrenta.com',
                id: 'Y2lzY29zcGFyazovL3VzL1BFT1BMRS82MGUzODk4ZC1hOWE4LTQwODItOWM0Yy01MmM2ZmNjMjExMWI'
            },
            claudio: {
                email: 'claudio.gottardo@delbrenta.com',
                id: 'Y2lzY29zcGFyazovL3VzL1BFT1BMRS9mYjdkMjA4YS0wNjMwLTRiODgtOTIyZS1jNmE2N2IzZjYxNWE'
            },
            marco_g: {
                email: 'marco.gobbi@delbrenta.com',
                id: 'Y2lzY29zcGFyazovL3VzL1BFT1BMRS9lYTY2OTdlZS1kYjA3LTRlNjMtYWZkZS0xMjMzZmRiNjQxNTE'
            },
            sergio: {
                email: 'sergio.madruzza@delbrenta.com',
                id: 'Y2lzY29zcGFyazovL3VzL1BFT1BMRS8wYTE5NzAwZi1hZDgxLTRiMGQtYjg5Mi05NmRjMTc0NDRmOTI'
            },
            stefano_z: {
                email: 'stefano.zagari@delbrenta.com',
                id: 'Y2lzY29zcGFyazovL3VzL1BFT1BMRS9iNWQzODRjYy1mNGYyLTQyMTQtOTNkZi0xNDU4ZGI4ZTMyYWI'
            },
            emanuele: {
                email: 'emanuele.delorenzi@delbrenta.com',
                id: 'Y2lzY29zcGFyazovL3VzL1BFT1BMRS85ZTkxMmRlNi1jNWFlLTQ1YzQtYjZhZi04N2E1ZDU5YzEyNDk'
            },
            giulia: {
                email: 'giulia.bagnolini@delbrenta.com',
                id: 'Y2lzY29zcGFyazovL3VzL1BFT1BMRS82Y2UxZTExZi00MDI2LTQxNzYtOTk2MS0xMjQ0ZTZlZWY0NzQ'
            },
            luciano: {
                email: 'luciano.polato@delbrenta.com',
                id: 'Y2lzY29zcGFyazovL3VzL1BFT1BMRS81MWRhYzkwOC01YWM0LTRlNDAtYTc4OC1lMGVkNTRlODExZWQ'
            },
            stefano: {
                email: 'stefano.bezzon@delbrenta.com',
                id: 'Y2lzY29zcGFyazovL3VzL1BFT1BMRS84MmJjMmU5MC03YjNkLTQxNmEtOTdiNS05MDFmNmNlZWM3ZDQ'
            },
            stefano_b: {
                email: 'stefano.bezzon@delbrenta.com',
                id: 'Y2lzY29zcGFyazovL3VzL1BFT1BMRS84MmJjMmU5MC03YjNkLTQxNmEtOTdiNS05MDFmNmNlZWM3ZDQ'
            }
        }
    }

    /**
     * TODO: rooms to remove
     * Y2lzY29zcGFyazovL3VzL1JPT00vZjlmMjdlNjAtODFlYS0xMWU5LTgxZmUtZTk2NWE5YTc1MWVk
     * Y2lzY29zcGFyazovL3VzL1JPT00vMjllNzFlMDAtY2U2Mi0xMWU5LTkzMDMtNzk0YWZiNjhmMDQ4
     * Y2lzY29zcGFyazovL3VzL1JPT00vODMwZDEzZTAtY2U2Mi0xMWU5LWE0MWMtZjljODdlYjRmOGY2
     * Y2lzY29zcGFyazovL3VzL1JPT00vZGVmOWNhZTAtY2U2Mi0xMWU5LTg3NWMtY2JlZDZkMDA4YmUx
     * Y2lzY29zcGFyazovL3VzL1JPT00vNDQzYWM1ODAtY2YyNi0xMWU5LWIyMGMtMTViMTRiNWJiZjVi
     * Y2lzY29zcGFyazovL3VzL1JPT00vZDk2ZmEyODAtY2ZhYi0xMWU5LTljZmMtY2Q2NTFiNjkwMTk3
     * Y2lzY29zcGFyazovL3VzL1JPT00vYjYzZWM5MDAtY2YxZC0xMWU5LTg2YTAtOTE3YTk1N2JkMjEw
     * Y2lzY29zcGFyazovL3VzL1JPT00vNmFmNmRhMjAtY2YxYi0xMWU5LWI5NjItYzM3ODA2YTk3YTFk
     * Y2lzY29zcGFyazovL3VzL1JPT00vNzNiOTVjZDAtY2U2NC0xMWU5LTk3ZDEtZTUxZTRiMGY0NDcz
     * Y2lzY29zcGFyazovL3VzL1JPT00vMDk2NTA4MDAtY2U1Yy0xMWU5LTk4YjktOWY5NjZmNjU4YWQy
     *
     * @param guest
     * @param agent
     * @returns {Promise<Room>}
     */

    async create( guest, agent ) {
        this.agent = agent;
        this.guest = guest;
        let connection = this.manager.getConnection();
        this.room = await connection.spark.rooms.create({ title: `MR-${guest.lastname.toLowerCase()}-${agent.toLowerCase()}` });
        // await this.__store( room );

        // await connection.spark.memberships.list({
        //     roomId: room.id,
        //     personId: this.botPersonId
        // }).then( memberships =>  {
        //     let membership = memberships.items[0];
        //     membership.isModerator = true;
        //     connection.spark.memberships.update(membership)
        // });

        return this;
    }

    async __store( room ) {
        let data = new FormData();
        data.append('guest_id', this.guest.id);
        data.append('name', room.title);
        data.append( 'identifier', room.id );
        data.append( 'agent', this.agent );

        await axios.post( '/cisco/assign/room', data )
            .then( response => {
                this.room = response.data
            } )

        return this;
    }

    addMembers( guestToken, agent ) {
        let connection = this.manager.getConnection();

        return connection.spark.memberships.create({
            personEmail: this.agents[agent].email,
            // personEmail: 'marco.comerci@delbrenta.com',
            roomId: this.room.id
        })
            .then(membership => {
                if( agent !== 'stefano_b' ) {
                    return connection.spark.memberships.create({
                        personEmail: 'stefano.bezzon@delbrenta.com',
                        roomId: this.room.id
                    })
                }

                return membership;
            })
            .then(membership => {
                return connection.spark.memberships.create({
                    personEmail: 'modelleria.remota@delbrenta.com',
                    roomId: this.room.id
                })
            })
            .then( () => {
                return connection.authenticateAsUser( guestToken ).request({
                    method: 'GET',
                    service: 'hydra',
                    resource: 'people/me'
                })
            })
            .then(guest => {
                return connection.authenticateAsBot().memberships.create({
                    personId: guest.body.id,
                    roomId: this.room.id
                })
            })
    }
}